import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logos/logo.png';
const _withScopeId = (n) => (_pushScopeId("data-v-707c972d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login-form" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "img4",
        alt: "default",
        src: _imports_0
    })
], -1));
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary btn-block"
    }, "Log in")
], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
            _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.form.email) = $event)),
                    class: "form-control",
                    placeholder: "Email",
                    required: "required"
                }, null, 512), [
                    [_vModelText, _ctx.form.email]
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.password) = $event)),
                    class: "form-control",
                    placeholder: "Password",
                    required: "required"
                }, null, 512), [
                    [_vModelText, _ctx.form.password]
                ])
            ]),
            _hoisted_5
        ], 32),
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
    ]));
}
